// DRAFT: эти списки подсказок требуют ревью врача/нутрициолога до production.
// Они вынесены из UI-кода, чтобы будущий content-review находил их по одному файлу.

export const symptomSuggestions = [
  'Головные боли',
  'Тревожность',
  'Проблемы с кожей',
  'Пищеварительный дискомфорт',
  'Выпадение волос',
];

export const chronicSuggestions = [
  'Сердце и сосуды',
  'Артериальное давление',
  'Сахар / углеводный обмен',
  'Щитовидная железа',
  'Желудок и кишечник',
];

export const familySuggestions = [
  'Диабет',
  'Гипертония',
  'Заболевания сердца',
  'Онкология',
  'Заболевания щитовидной железы',
];
